import axios from "axios";
import {useEffect, useMemo, useState} from "react";
import DataTable from "react-data-table-component";
import {Button, Card, CardBody, CardHeader, Col, Input, Modal, ModalBody, ModalHeader, Row,} from "reactstrap";
import classStyle from "../payout.module.css";
import {APIClient, sessionToken} from "../../../assets/config/sessionToken";
import base64 from "base-64";
import {useLocation, useParams} from "react-router-dom";
import DataTableExtensions from "react-data-table-component-extensions";
import {api} from "../../../globalConfig";
import ImageModel from "../../imageModel/ImageModel";
import {projects_leads_api} from "../../../assets/utils/sow";
import {CSVLink} from "react-csv";
import {qcSubmitclient, tabledata,} from "../../../assets/utils/dashboard";
import {fetchSessionUser} from '../../../assets/utils/sessionData.js';
import GeneratePdf from '../PDF/generatePDF';
import ImageModal from '../Modal/image-Modal';
import RemarkModal from '../Modal/remark_Modal.js';
import LenovoModel from '../Modal/Lenovo-Model.js';
import {LENOVO_PROJECT_ENDPOINT_MAP} from '../../../common/constants.js';


export const BasicTable = ({setChk, chk}) => {
    const path = useLocation();
    const [urlTable, setUrlTable] = useState("");
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [colm, setColm] = useState([]);
    const [view, setView] = useState([]);
    const [image, setImage] = useState("");
    const [admin, setAdmin] = useState(false);
    const [modal_center, setmodal_center] = useState(false);
    const [open, setOpen] = useState(false);
    const [openNcml, setOpenNcml] = useState(false);
    const [open2, setOpen2] = useState(false);
    const [open3, setOpen3] = useState(false);
    const [open4, setOpen4] = useState(false);
    const [dataArray, setDataArray] = useState({});
    const [viewArray, setViewArray] = useState([]);
    const [colArray, setColArray] = useState([]);
    const [rowData, setRowData] = useState({});
    const [imageData, setImageData] = useState("");
    const [leadData, setLeadData] = useState([]);
    const [appRemark, setAppRemark] = useState("");
    const [rejRemark, setRejRemark] = useState("");
    const [check, setCheck] = useState(false);
    const [user_type, set_user_type] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [currentLeadData, setCurrentLeadData] = useState(null)
    const [openAuditModal, setOpenAuditModal] = useState(false)

    // const [toast1, setToast1] = useState(false);

    const token = sessionStorage.getItem("token");

    const final = path.pathname.slice(1);
    const split = final.split("/");

    const Cap = split[0][0].toUpperCase() + split[0].slice(1);

    const code = path.search?.split(":");

    var bytes = base64.decode(code[1]);

    const location = useLocation();
    const prjId = location.pathname?.split("/")[2];

    // const bytesApi =
    const dataEnter = {
        project_name: bytes,
        project_id: path.pathname,
    };
    const config = {
        headers: {
            "x-access-token": sessionToken,
        },
    };
    const id = useParams();
    const prjIds = JSON.parse(sessionStorage.getItem("projectID"));
    const idnum = Number(id.id);

    function tog_center() {
        setmodal_center(!modal_center);
    }

    useEffect(() => {
        fetchSessionUser().then(res => {
            if (res?.data?.admin === "admin") {
                setAdmin(true);
            }
        })


        if (prjIds.includes(idnum)) {
            const urlApi = api.COMMON_URL + projects_leads_api;
            const urlData = new APIClient();
            setLoading(true);
            urlData
                .get(urlApi, {project_id: id.id})
                .then((res) => {
                    setUrlTable(res.data.leads);
                    setLoading(false);
                })
                .catch((err) => console.log(err.response, "err"));
        }
    }, [path, admin, check]);

    useEffect(() => {
        fetchSessionUser().then(res => {
            set_user_type(res.data?.admin);
        })
    }, []);

    const handleLeadDet = (row) => {
        setRowData(row);

        const isLenovoProject = Object.keys(LENOVO_PROJECT_ENDPOINT_MAP).includes(prjId);

        let url, config;

        // Generate Path and config params
        if (isLenovoProject) {
            const endpoint = LENOVO_PROJECT_ENDPOINT_MAP[prjId];
            url = `${api.COMMON_URL}/${endpoint}?lead_id=${row.lead_id}`;
            config = {};
        } else {
            url = `${api.FARM_URL}${tabledata}`;
            config = {
                params: {
                    project_id: prjId,
                    lead_id: row.main_lead,
                }
            };
        }

        // API Call
        axios.get(url, config)
            .then((res) => {
                if (isLenovoProject) {
                    setOpenAuditModal(true);
                    setLeadData(JSON.parse(res.data.results[0].result));
                } else {
                    prjId == 337 ? setOpen(true) : setOpenNcml(true);
                    setLeadData(res.data.data);
                }


            })
            .catch((err) => console.error(err))
            .finally(() => console.log('API completed'));
    };


    const handleApprove = () => {
        const path = api.FARM_URL_QC + "/" + qcSubmitclient;
        const postData = {
            lead_id: rowData.main_lead,
            qc_status: "1",
            qc_remark: appRemark,
        };

        console.log('kk')

        axios
            .put(path, postData)
            .then((res) => {
                // successnotify("success");
                setOpen3(!open3);
                setTimeout(() => {
                    setOpen(false);
                    setOpenNcml(false);
                }, 300);
                setCheck(!check);
                setChk(!chk);
            })
            .catch(() => alert("error"));
    };
    const handleReject = () => {
        const path = api.FARM_URL_QC + "/" + qcSubmitclient;
        const postData = {
            lead_id: rowData.main_lead,
            qc_status: "3",
            qc_remark: rejRemark,
        };

        axios
            .put(path, postData)
            .then((res) => {
                setOpen4(!open4);
                setTimeout(() => {
                    setOpen(false);
                    setOpenNcml(false);
                }, 300);
                setCheck(!check);
                setChk(!chk);
            })
            .catch(() => alert("error"));
    };

    const columns = [
        {
            name: <span className="font-weight-bold fs-13">Lead ID.</span>,
            selector: (row) => row.main_lead,
            sortable: true,
        },
        {
            name: <span className="font-weight-bold fs-13">Date</span>,
            selector: (row) => row.date,
            sortable: true,
        },

        {
            name: <span className="font-weight-bold fs-13">Merchant Name</span>,
            selector: (row) => row.merchant_name,
            sortable: true,
        },
        {
            name: <span className="font-weight-bold fs-13">Merchant Number</span>,
            selector: (row) => row.merchant_number,
            sortable: true,
        },
        {
            name: <span className="font-weight-bold fs-13">City</span>,
            selector: (row) => row.city,
            sortable: true,
        },
        {
            name: <span className="font-weight-bold fs-13">State</span>,
            selector: (row) => row.state,
            sortable: true,
        },
        {
            name: <span className="font-weight-bold fs-13">QC Status</span>,
            sortable: true,
            selector: (cell) => {
                switch (cell.final_qc) {
                    case "rejected":
                        return (
                            <span className="badge badge-soft-danger"> {cell.final_qc} </span>
                        );
                    case "pending":
                        return (
                            <span className="badge badge-soft-warning">
                {" "}
                                {cell.final_qc}{" "}
              </span>
                        );

                    default:
                        return (
                            <span className="badge badge-soft-success">
                {" "}
                                {cell.final_qc}{" "}
              </span>
                        );
                }
            },
        },
        {
            name: <span className="font-weight-bold fs-13 ">View</span>,
            sortable: true,
            center: true,
            width: "100px",
            cell: (row) => (
                <i
                    className="ri-eye-fill align-bottom me-2 text-muted cursor-pointer"
                    onClick={() => {
                        // handleLeads(row);
                        handleLeadDet(row);
                        setCurrentLeadData(row);
                    }}
                ></i>
            ),
        },
    ];

    const parseDateValue = (dateStr) => {
        if (!dateStr) return null;
        const trimmed = dateStr.trim();
        if (!trimmed) return null;

        // Try DD/MM/YYYY or MM/DD/YYYY
        const parts = trimmed.split("/");
        if (parts.length === 3) {
            const [a, b, c] = parts.map((segment) => segment.replace(/^0+/, "") || "0");
            if (/^\d{4}$/.test(a) && /^\d{1,2}$/.test(b) && /^\d{1,2}$/.test(c)) {
                return new Date(Number(a), Number(b) - 1, Number(c));
            }
            if (/^\d{1,2}$/.test(a) && /^\d{1,2}$/.test(b) && /^\d{4}$/.test(c)) {
                return new Date(Number(c), Number(b) - 1, Number(a));
            }
        }

        // Try DD-MMM-YYYY or similar
        const monthNameMatch = trimmed.match(/^([0-9]{1,2})\s+([A-Za-z]+)\s+([0-9]{4})/);
        if (monthNameMatch) {
            const [, day, monthName, year] = monthNameMatch;
            const monthIndex = [
                "jan", "feb", "mar", "apr", "may", "jun",
                "jul", "aug", "sep", "oct", "nov", "dec",
            ].indexOf(monthName.toLowerCase().slice(0, 3));
            if (monthIndex >= 0) {
                return new Date(Number(year), monthIndex, Number(day));
            }
        }

        const dashMonthNameMatch = trimmed.match(/^([0-9]{1,2})-([A-Za-z]+)-([0-9]{4})/);
        if (dashMonthNameMatch) {
            const [, day, monthName, year] = dashMonthNameMatch;
            const monthIndex = [
                "jan", "feb", "mar", "apr", "may", "jun",
                "jul", "aug", "sep", "oct", "nov", "dec",
            ].indexOf(monthName.toLowerCase().slice(0, 3));
            if (monthIndex >= 0) {
                return new Date(Number(year), monthIndex, Number(day));
            }
        }

        const parsed = new Date(trimmed);
        return Number.isNaN(parsed.getTime()) ? null : parsed;
    };

    const filteredData = useMemo(
        () =>
            urlTable && Array.isArray(urlTable) ? urlTable.filter((row) => {
                if (!fromDate && !toDate) return true;

                const rowDate = parseDateValue(row?.date);
                if (!rowDate) return false;

                if (fromDate) {
                    const from = new Date(fromDate);
                    from.setHours(0, 0, 0, 0);
                    if (rowDate < from) return false;
                }

                if (toDate) {
                    const to = new Date(toDate);
                    to.setHours(23, 59, 59, 999);
                    if (rowDate > to) return false;
                }

                return true;
            }) : [],
        [urlTable, fromDate, toDate]
    );

    const tableEnter = {
        columns,
        data: filteredData,
    };

    return loading ? (
        <h4 className="text-center">loading table content.... </h4>
    ) : (
        <>
            {tableEnter && (
                <Card>
                    <CardHeader style={{marginBottom: "-5px", background: "#F3F3F8"}}>
                        <Row className="align-items-end g-3">
                            <Col xs={12} sm={6} md={3} lg={2}>
                                <label className="form-label mb-1">From Date</label>
                                <Input
                                    type="date"
                                    value={fromDate}
                                    onChange={(e) => setFromDate(e.target.value)}
                                />
                            </Col>
                            <Col xs={12} sm={6} md={3} lg={2}>
                                <label className="form-label mb-1">To Date</label>
                                <Input
                                    type="date"
                                    value={toDate}
                                    onChange={(e) => setToDate(e.target.value)}
                                />
                            </Col>
                            <Col xs={12} sm={6} md={3} lg={1}>
                                <div className="d-grid mt-2">
                                    <Button
                                        color="secondary"
                                        outline
                                        onClick={() => {
                                            setFromDate("");
                                            setToDate("");
                                        }}
                                    >
                                        Clear
                                    </Button>
                                </div>
                            </Col>
                            <Col xs={12} sm={6} md={3} lg={4} className="text-md-end">
                                <div className="d-flex flex-md-row align-items-md-center justify-content-md-end gap-2">
                                    <span className="text-muted">Showing {filteredData.length} rows</span>
                                    <CSVLink
                                        className="btn btn-primary"
                                        data={filteredData}
                                    >
                                        <i className=" ri-download-2-line align-middle me-1"></i>
                                        Download
                                    </CSVLink>
                                </div>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <DataTableExtensions
                            {...tableEnter}
                            export={false}
                            print={true}
                            filterHidden={true}
                            filterPlaceholder={`Search`}
                        >
                            <DataTable columns={columns} data={tableEnter.data} pagination/>
                        </DataTableExtensions>
                    </CardBody>
                </Card>
            )}

            <Modal
                isOpen={modal_center}
                toggle={() => {
                    tog_center();
                }}
                centered={true}
            >
                <ImageModel img2={image}/>
            </Modal>

            {openAuditModal &&
                <LenovoModel rowData={rowData} leadData={leadData} openAuditModal={openAuditModal} setOpenAuditModal={setOpenAuditModal}/>
            }
            {openNcml ? (
                <>
                    <Modal
                        // className="modal-fullscreen"
                        id="exampleModalFullscreen"
                        tabIndex="-1"
                        isOpen={openNcml}
                        toggle={() => {
                            setOpenNcml(false);
                            setRowData({});
                        }}
                        centered={true}
                        size={"xl"}
                    >
                        <div className="d-flex justify-content-end align-items-center">
                            <a
                                href={`https://farming-backend.taskmo.in/common/downloadLead?lead_id=${rowData.main_lead}&token=${token}&project_id=${prjId}`}
                                target="_blank"
                                rel="noreferrer"
                                download
                                className="cursor-pointer "
                            >
                                <i
                                    className=" ri-download-2-line text-primary "
                                    style={{ fontSize: "19px" }}
                                ></i>
                            </a>
                            <ModalHeader
                                className="p-3 "
                                toggle={() => {
                                    setOpenNcml(false);
                                }}
                            >
                            </ModalHeader>
                        </div>
                        <ModalBody style={{overflowX: "scroll"}}>
                            <Row>
                                <Col
                                    sm={12}
                                    className="d-flex mb-5"
                                    style={{overflowX: "scroll", height: "60vh", width: "100%"}}
                                >
                                    <table style={{width: "100%"}}>
                                        <tr
                                            className={classStyle.tr_leads}
                                            key="111"
                                            style={{position: "sticky", top: "0px"}}
                                        >
                                            <td
                                                className={classStyle.td_leads}
                                                style={{background: "#F2E7FF"}}
                                            >
                                                <p
                                                    style={{
                                                        margin: "0",
                                                        color: "#495057",
                                                    }}
                                                >
                                                    Sl No
                                                </p>
                                            </td>
                                            <td
                                                className={classStyle.td_leads}
                                                style={{background: "#F2E7FF"}}
                                            >
                                                <p style={{margin: "0", color: "#495057"}}>Title</p>
                                            </td>
                                            {/* <td
                        className={classStyle.td_leads}
                        style={{ background: '#F2E7FF' }}
                      >
                        <p style={{ margin: '0', color: '#495057' }}>Status</p>
                      </td> */}
                                            <td
                                                className={classStyle.td_leads}
                                                style={{background: "#F2E7FF"}}
                                            >
                                                <p style={{margin: "0", color: "#495057"}}>Answer</p>
                                            </td>
                                            {/* <td
                        className={classStyle.td_leads}
                        style={{ background: '#F2E7FF' }}
                      >
                        <p style={{ margin: '0', color: '#495057' }}>Image</p>
                      </td> */}
                                        </tr>
                                        {leadData?.map((item, index) => {
                                            return (
                                                <>
                                                    <tr>
                                                        <td className={classStyle.td_leads}>
                                                            <p style={{margin: "0", color: "#495057"}}>
                                                                {index + 1}
                                                            </p>
                                                        </td>
                                                        <td className={classStyle.td_leads}>
                                                            <p
                                                                style={{
                                                                    margin: "0",
                                                                    color: "#495057",
                                                                    height: "60px",
                                                                    alignItems: "center",
                                                                }}
                                                            >
                                                                {item.title}
                                                            </p>
                                                        </td>
                                                        {/* <td className={classStyle.td_leads}>
                              <p style={{ margin: '0', color: '#495057' }}>
                                {item.status ? item.status : '-'}
                              </p>
                            </td> */}
                                                        {item.type == "view" ? (
                                                            <td className={classStyle.td_leads}>
                                                                <p
                                                                    style={{
                                                                        margin: "0",
                                                                        color: "#495057",
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={
                                                                            item.value
                                                                                ? item.value
                                                                                : require("../../../assets/images/no_image_available.png")
                                                                        }
                                                                        onError={({currentTarget}) => {
                                                                            currentTarget.onerror = null; // prevents looping
                                                                            currentTarget.src = require("../../../assets/images/no_image_available.png");
                                                                        }}
                                                                        alt=""
                                                                        className="rounded avatar-md "
                                                                        style={{
                                                                            padding: "7px 7px 7px 0px",
                                                                            // marginRight: "4px",
                                                                        }}
                                                                        onClick={() => {
                                                                            setOpen2(true);
                                                                            setImageData(item.value);
                                                                        }}
                                                                    />
                                                                </p>
                                                            </td>
                                                        ) : item.type == "multiple_view" ? (
                                                            <td
                                                                className={classStyle.td_leads}
                                                                style={{width: "400px"}}
                                                            >
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        width: "400px",
                                                                        overflowX: "scroll",
                                                                    }}
                                                                >
                                                                    {item.value.map((it) => {
                                                                        return (
                                                                            <>
                                                                                <div>
                                                                                    <p
                                                                                        style={{
                                                                                            margin: "0",
                                                                                            color: "#495057",
                                                                                            // background: "green",
                                                                                        }}
                                                                                    >
                                                                                        <img
                                                                                            src={
                                                                                                it
                                                                                                    ? it
                                                                                                    : require("../../../assets/images/no_image_available.png")
                                                                                            }
                                                                                            onError={({currentTarget}) => {
                                                                                                currentTarget.onerror = null; // prevents looping
                                                                                                currentTarget.src = require("../../../assets/images/no_image_available.png");
                                                                                            }}
                                                                                            alt=""
                                                                                            className="rounded avatar-md "
                                                                                            style={{
                                                                                                padding: "7px 7px 7px 0px",
                                                                                            }}
                                                                                            onClick={() => {
                                                                                                setOpen2(true);
                                                                                                setImageData(it);
                                                                                            }}
                                                                                        />
                                                                                    </p>
                                                                                </div>
                                                                            </>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </td>
                                                        ) : (
                                                            <td className={classStyle.td_leads}>
                                                                <p style={{margin: "0", color: "#495057"}}>
                                                                    {item.value}
                                                                </p>
                                                            </td>
                                                        )}
                                                    </tr>
                                                </>
                                            );
                                        })}
                                    </table>
                                </Col>
                                <Col md={12}>
                                    <div
                                        style={{
                                            // a
                                            bottom: "0px",
                                            // top: "780px",
                                            width: "100%",
                                        }}
                                    >
                                        {user_type === "admin" && (
                                            <div
                                                // className="d-flex justify-content-evenly "
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "end",
                                                    gap: "10px",
                                                }}
                                            >
                                                <button
                                                    type="button"
                                                    className="btn btn-success btn-label waves-effect waves-light"
                                                    onClick={() => setOpen3(true)}
                                                >
                                                    <i className="ri-check-line label-icon align-middle fs-16 me-2"></i>{" "}
                                                    Approve
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-danger btn-label waves-effect waves-light"
                                                    onClick={() => setOpen4(true)}
                                                >
                                                    <i className=" ri-close-line label-icon align-middle fs-16 me-2"></i>
                                                    Reject
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        </ModalBody>
                    </Modal>
                </>
            ) : (
                <>
                    {open && (
                        <Modal
                            // className="modal-fullscreen"
                            id="exampleModalFullscreen"
                            tabIndex="-1"
                            isOpen={open}
                            toggle={() => {
                                setOpen(false);
                                setRowData({});
                            }}
                            centered={true}
                            size={"xl"}
                        >
                            <div className="d-flex justify-content-end align-items-center">
                                <a
                                    href={`https://farming-backend.taskmo.in/common/downloadLead?lead_id=${rowData.main_lead}&token=${token}&project_id=${prjId}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    download
                                    className="cursor-pointer "
                                >
                                    <i
                                        className=" ri-download-2-line text-primary "
                                        style={{fontSize: "19px"}}
                                    ></i>
                                </a>
                                <ModalHeader
                                    className="p-3 "
                                    toggle={() => {
                                        setOpen(false);
                                    }}
                                >
                                </ModalHeader>
                            </div>
                            <ModalBody style={{overflowX: "scroll"}}>
                                <Row>
                                    <Col
                                        sm={12}
                                        className="d-flex mb-5"
                                        style={{
                                            overflowX: "scroll",
                                            height: "60vh",
                                            width: "100%",
                                        }}
                                    >
                                        <table style={{width: "100%"}}>
                                            <tr
                                                className={classStyle.tr_leads}
                                                key="111"
                                                style={{position: "sticky", top: "0px"}}
                                            >
                                                <td
                                                    className={classStyle.td_leads}
                                                    style={{background: "#F2E7FF"}}
                                                >
                                                    <p
                                                        style={{
                                                            margin: "0",
                                                            color: "#495057",
                                                        }}
                                                    >
                                                        Sl No
                                                    </p>
                                                </td>
                                                <td
                                                    className={classStyle.td_leads}
                                                    style={{background: "#F2E7FF"}}
                                                >
                                                    <p style={{margin: "0", color: "#495057"}}>Title</p>
                                                </td>
                                                <td
                                                    className={classStyle.td_leads}
                                                    style={{background: "#F2E7FF"}}
                                                >
                                                    <p style={{margin: "0", color: "#495057"}}>
                                                        Status
                                                    </p>
                                                </td>
                                                <td
                                                    className={classStyle.td_leads}
                                                    style={{background: "#F2E7FF"}}
                                                >
                                                    <p style={{margin: "0", color: "#495057"}}>
                                                        Answer
                                                    </p>
                                                </td>
                                                <td
                                                    className={classStyle.td_leads}
                                                    style={{background: "#F2E7FF"}}
                                                >
                                                    <p style={{margin: "0", color: "#495057"}}>Image</p>
                                                </td>
                                            </tr>
                                            {leadData?.map((item, index) => {
                                                return (
                                                    <>
                                                        <tr>
                                                            <td className={classStyle.td_leads}>
                                                                <p style={{margin: "0", color: "#495057"}}>
                                                                    {index + 1}
                                                                </p>
                                                            </td>
                                                            <td className={classStyle.td_leads}>
                                                                <p style={{margin: "0", color: "#495057"}}>
                                                                    {item.title}
                                                                </p>
                                                            </td>
                                                            <td className={classStyle.td_leads}>
                                                                <p style={{margin: "0", color: "#495057"}}>
                                                                    {item.status ? item.status : "-"}
                                                                </p>
                                                            </td>
                                                            <td className={classStyle.td_leads}>
                                                                <p style={{margin: "0", color: "#495057"}}>
                                                                    {item.value}
                                                                </p>
                                                            </td>
                                                            <td className={classStyle.td_leads}>
                                                                <p style={{margin: "0", color: "#495057"}}>
                                                                    <img
                                                                        src={
                                                                            item.image
                                                                                ? item.image
                                                                                : require("../../../assets/images/no_image_available.png")
                                                                        }
                                                                        onError={({currentTarget}) => {
                                                                            currentTarget.onerror = null; // prevents looping
                                                                            currentTarget.src = require("../../../assets/images/no_image_available.png");
                                                                        }}
                                                                        alt=""
                                                                        className="rounded avatar-md "
                                                                        style={{padding: "7px 7px 7px 0px"}}
                                                                        onClick={() => {
                                                                            setOpen2(true);
                                                                            setImageData(item.image);
                                                                        }}
                                                                    />
                                                                </p>
                                                            </td>
                                                        </tr>
                                                    </>
                                                );
                                            })}
                                        </table>
                                    </Col>
                                    <Col md={12}>
                                        <div
                                            style={{
                                                // a
                                                bottom: "0px",
                                                // top: "780px",
                                                width: "100%",
                                            }}
                                        >
                                            {user_type === "admin" && (
                                                <div
                                                    // className="d-flex justify-content-evenly "
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "end",
                                                        gap: "10px",
                                                    }}
                                                >
                                                    <button
                                                        type="button"
                                                        className="btn btn-success btn-label waves-effect waves-light"
                                                        onClick={() => setOpen3(true)}
                                                    >
                                                        <i className="ri-check-line label-icon align-middle fs-16 me-2"></i>{" "}
                                                        Approve
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-label waves-effect waves-light"
                                                        onClick={() => setOpen4(true)}
                                                    >
                                                        <i className=" ri-close-line label-icon align-middle fs-16 me-2"></i>
                                                        Reject
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </ModalBody>
                        </Modal>
                    )}
                </>
            )}

            <ImageModal open={open2} setOpen={setOpen2} imageData={imageData}/>

            // Approve Remark Modal
            <RemarkModal open={open3} setOpen={setOpen3} setRemark={setAppRemark} actionHandler={handleApprove}/>

            // Reject Remark Modal
            <RemarkModal open={open4} setOpen={setOpen4} setRemark={setRejRemark} actionHandler={handleReject}/>
        </>
    );
};
